import React from 'react';
import { Alert, Box } from '@mui/material';
import { UnifiedHoursEditor } from '../../StoreHours/UnifiedHoursEditor';
import { AVAILABLE_OCCASIONS, type BulkHoursEditorProps } from './types';

export const BulkHoursEditor: React.FC<BulkHoursEditorProps> = ({ onChange }) => {
  return (
    <Box sx={{ p: 1 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Updating Carryout hours will also update 3rd Party Delivery aggregator hours to match.
      </Alert>
      <UnifiedHoursEditor
        availableOccasions={AVAILABLE_OCCASIONS}
        onChange={onChange}
        showTemplates={true}
        showSpecialHours={false}
      />
    </Box>
  );
};
